'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useState } from 'react';

export interface Queryly {
  init: (id: string, list: NodeListOf<Element>, version: { uiversion: number }) => void;
}

export const QuerylyScript: React.FC = () => {
  const pathname = usePathname();
  const isAdvancedSearch = pathname === '/advanced-search';
  const [loaded, setLoaded] = useState(false);
  const [advancedSearchScript, setAdvancedSearchScript] = useState(false);

  useEffect(() => {
    if (loaded && isAdvancedSearch) {
      setAdvancedSearchScript(true);
    }
  }, [loaded, isAdvancedSearch]);

  return (
    <>
      {/* this script will add the search overlay by searching for a label with htmFor='queryly_toggle' */}
      <Script
        onLoad={() => {
          // Initialize Queryly by searching for places that the search needs control over
          // #root is not in our DOM
          window.queryly.init(process.env.QUERYLY_ID!, document.querySelectorAll('#content,header,footer'), {
            uiversion: 1,
          });
          setLoaded(true);
        }}
        src='https://www.queryly.com/js/queryly.v4.min.js'
        strategy='lazyOnload'
      />
      {/* this script is just for the advanced search page */}
      {advancedSearchScript ? <Script src='https://www.queryly.com/js/fortune-advanced-search.js' /> : null}
    </>
  );
};
